import { makeStyles } from "tss-react/mui";
import { MiIcon, MiIconButton } from "@miplatform/components";
import { ICONS_WEB } from "@miplatform/constants";
import * as mdi from "@mdi/js";

export function CollapsibleIcon({
  isCollapsed = false,
  onCollapse = () => {},
  disabled = false,
}) {
  const { classes } = useStyles({ isCollapsed });

  return (
    <MiIconButton
      className={classes.expandIconContainer}
      onClick={onCollapse}
      disabled={disabled}
    >
      <MiIcon
        path={mdi[ICONS_WEB.CHEVRON_DOWN]}
        className={classes.rotateIcon}
      />
    </MiIconButton>
  );
}

const useStyles = makeStyles()((theme, { isCollapsed }) => ({
  expandIconContainer: {
    color: theme.palette.grey.main,
    ":hover": { backgroundColor: theme.palette.grey.light, borderRadius: 4 },
    display: "flex",
    alignItems: "center",
    padding: 0,
  },
  rotateIcon: {
    transition: "transform 0.3s ease-in-out",
    transform: isCollapsed ? "rotate(180deg)" : "rotate(0deg)",
  },
}));
